import useMutation from "src/hooks/useMutation";

function useCustomAddressRemove() {
  return useMutation({
    path: `/api/v1/customers/customerId/addresses/addressId`,
    method: "DELETE",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/customers/customerId/addresses`,
      shouldRevalidate: true,
    },
  });
}

export default useCustomAddressRemove;
